// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__20rjc","error":"Textarea_error__252Sl","readonly":"Textarea_readonly__3YMa0","disabled":"Textarea_disabled__2Vlnh"};